<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "FreeeSelectCompany",
  components: {
  },
  mixins: [],
  props: {
    provider: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      form: { linkage_id: null, linkage_name: null },
      companies: null,
    }
  },
  computed: {
    ...mapState("DriverProviderSetting", {
      state: "state",
    }),
    ...mapGetters("DriverProviderSetting", [
      "isConfigured",
    ])
  },
  watch: {
  },
  created() {
    this.fetchCompanies().then((content) => {
      this.companies = content.companies
    })
  },
  methods: {
    ...mapActions("DriverProviderFreeeCompany", {
      fetchCompanies: "index",
      updateCompany: "update"
    }),
    registerButtonClickEvent () {
      this.$refs.providerValidator.validate().then((result) => {
        if(result){
          console.log("")
        }
      })
    },
  },


}
</script>

<template>
  <div>
    <validation-observer ref="providerValidator">
      <v-card>
        <v-card-title>
          freee請求連携
        </v-card-title>
        <v-card-subtitle>
          連携されたfreeeのアカウントには複数の事業所が紐付いています。<br />
          連携する事業所を選択してください。
        </v-card-subtitle>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="12" md="5">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="事業所"
                class="requiredMark"
              >
                <v-select
                  v-model="form.linkage_id"
                  :error-messages="errors"
                  :items="companies"
                  dense
                  label="事業所"
                  outlined
                  hide-details="auto"
                  persistent-placeholder
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </div>
</template>
